module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domain_authority":"Domain Authority"},"fr":{"domain_authority":"Domain Authority"},"de":{"domain_authority":"Domänenautorität"}}')
  delete Component.options._Ctor
}
